import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// API URL interceptor - replaces localhost with production URL
const _originalFetch = window.fetch;
window.fetch = function(url, options) {
  if (typeof url === 'string' && url.includes('localhost:5000')) {
    url = url.replace(
      'http://localhost:5000',
      process.env.REACT_APP_API_URL || 'http://localhost:5000'
    );
  }
  return _originalFetch(url, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();